export default __webpack_public_path__ + "static/media/pikachuLoader.7b67fc2b.gif";